/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geolayerlive2Inputs */

const en_geolayerlive2 = /** @type {(inputs: Geolayerlive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live right now`)
};

const de_geolayerlive2 = /** @type {(inputs: Geolayerlive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jetzt live`)
};

/**
* | output |
* | --- |
* | "Live right now" |
*
* @param {Geolayerlive2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const geolayerlive2 = /** @type {((inputs?: Geolayerlive2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geolayerlive2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geolayerlive2(inputs)
	return de_geolayerlive2(inputs)
});
export { geolayerlive2 as "geoLayerLive" }